import { FC } from 'react';
import {
  GMB_SUPPORT_EMAIL,
  GMB_SUPPORT_PHONE_NUMBER,
  NEW_TAB_ATTRIBUTES,
} from 'src/common/constants';
import formatTel from 'src/common/utils/formatTel';
import styles from 'src/content/ContentPages.module.scss';

const AccessibilityStatement: FC = () => (
  <main className={styles.root}>
    <h1 className={styles.title}>Accessibility Statement</h1>
    <h3>Accessibility Statement for Getmyboat</h3>

    <p>
      Getmyboat is committed to ensuring digital accessibility for people with disabilities. We are
      continually improving the user experience for everyone, and applying the relevant
      accessibility standards.
    </p>

    <h3>Measures to Support Accessibility</h3>
    <p>Getmyboat takes the following measures to ensure accessibility of getmyboat.com:</p>
    <ul>
      <li>Include accessibility throughout our internal policies.</li>
      <li>Provide continual accessibility training for our staff.</li>
      <li>Assign clear accessibility targets and responsibilities.</li>
      <li>Employ formal accessibility quality assurance methods.</li>
      <li>Constantly analyzing and improving our digital assets using automated scanning tools.</li>
      <li>Developing new ways to improve user experience.</li>
    </ul>

    <h3>Conformance Status</h3>

    <p>
      The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and
      developers to improve accessibility for people with disabilities. It defines three levels of
      conformance: Level A, Level AA, and Level AAA. Getmyboat&apos;s website has been implementing
      changes to conform WCAG 2.0 level AA standard and improve user experience. We are currently in
      a process of identifying hard-to-navigate elements or non-complaint documents that need to be
      addressed and making changes.
    </p>
    <p>
      <strong>If you encounter a problem, please report it to: </strong>
      <a
        href={`mailto:${GMB_SUPPORT_EMAIL}`}
        className={styles.link}
        {...NEW_TAB_ATTRIBUTES}
      >
        {GMB_SUPPORT_EMAIL}
      </a>
    </p>

    <p>
      <strong>Portable Format Documents: </strong>
      Some materials on the website (for example, spec sheets and downloadable brochures) are
      published in portable document format (PDF) for users to download and print. In order to
      access these files, please ensure you have the latest version of Adobe Reader. Adobe Reader is
      available for free at the Adobe website. We also provide alternatives for those documents in
      text or HTML format.
    </p>
    <h3>Feedback</h3>

    <p>
      We welcome your feedback on the accessibility of Getmyboat. Please let us know if you
      encounter accessibility barriers on our website:
    </p>
    <ul>
      <li>
        Phone:
        {' '}
        <a
          href={`tel:${GMB_SUPPORT_PHONE_NUMBER}`}
          className={styles.link}
        >
          {formatTel(GMB_SUPPORT_PHONE_NUMBER)}
        </a>
      </li>
      <li>
        E-mail:
        {' '}
        <a
          href={`mailto:${GMB_SUPPORT_EMAIL}`}
          className={styles.link}
          {...NEW_TAB_ATTRIBUTES}
        >
          {GMB_SUPPORT_EMAIL}
        </a>
      </li>
      <li>
        Address:
        {' '}
        <address className={styles.address}>
          Getmyboat, Inc. 101 International Parkway, Adairsville, Georgia 30103
        </address>
      </li>
    </ul>
    <p>We try to respond to feedback within 1 business day.</p>

    <h3>Limitations and Alternatives</h3>

    <p>
      Despite our best efforts to ensure accessibility of getmyboat.com, there may be some
      limitations. Please report an issue to
      {' '}
      <a
        href={`mailto:${GMB_SUPPORT_EMAIL}`}
        className={styles.link}
        {...NEW_TAB_ATTRIBUTES}
      >
        {GMB_SUPPORT_EMAIL}
      </a>
      .
    </p>
  </main>
);

export default AccessibilityStatement;
